import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { analyticsApis } from "../utils/apis";
import {
  analyticsApiRequest,
  createAxiosInstanceAanlysis,
} from "../utils/request";

export const analyticsMember = createAsyncThunk(
  "analyticsMember",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceAanlysis();
      const response = await axiosInstance.get(
        `${analyticsApis.getMemberAnalytics}?user_id=${payload.userId}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const analyticsManager = createAsyncThunk(
  "analyticsManager",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceAanlysis();
      const response = await axiosInstance.get(
        `${analyticsApis.getManagerAnalytics}?user_id=${payload.userId}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getTutorialVideo = createAsyncThunk(
  "getTutorialVideo",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceAanlysis();
      const response = await axiosInstance.get(
        `${analyticsApis.getTutorialVideo}?id=${payload.tut_id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getAllLeads = createAsyncThunk("getAllLeads", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceAanlysis();
    const response = await axiosInstance.get(analyticsApis.getAllLeadsApi);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

// export const analyticsAdmin = createAsyncThunk(
//   "analyticsAdmin",
//   async (payload) => {
//     const response = await analyticsApiRequest(
//       "GET",
//       `${analyticsApis.getAdminAnalytics}?user_id=${payload.userId}`
//     );
//     return response;
//   }
// );

export const createLeads = createAsyncThunk("createLeads", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceAanlysis();
    const response = await axiosInstance.post(
      analyticsApis.createLeadsApi,
      payload
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

const analyticsSlice = createSlice({
  name: "analytics",
  initialState: {
    analytics: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(analyticsMember.pending, (state) => {
        state.loading = true;
      })
      .addCase(analyticsMember.fulfilled, (state, action) => {
        state.loading = false;
        state.loginData = action.payload;
      })
      .addCase(analyticsMember.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default analyticsSlice.reducer;
